import React from "react";
import { useAppSelector } from "src/store/store";
import { isAdminUser } from "src/constants/constants";
import { Navigate, useNavigate } from "react-router-dom";
type RequireAdminProps = {
  children: React.JSX.Element;
};
const RequireAdmin = ({ children }: RequireAdminProps) => {
  const { ldap } = useAppSelector((state) => state.user);
  if (!isAdminUser(ldap)) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
};

export default RequireAdmin;
